import React from 'react'
import { Button } from '../button/component'

import './styles.scss'

const ButtonControl = ({
	isHomeScreen,
	buttonText,
	onClick,
	skipText,
	onClickSkip,
	disabled = false,
}) => {
	return (
		<div className="button-wrapper">
			{isHomeScreen ? (
				<label className="button-label" htmlFor="file-input">
					{buttonText}
				</label>
			) : (
				<Button buttonText={buttonText} onClick={onClick} disabled={disabled} />
			)}

			{skipText && (
				<span className="skip-button" onClick={onClickSkip}>
					{skipText}
				</span>
			)}
		</div>
	)
}

export { ButtonControl }
